var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubbento0(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 186,
    height: 166,
    viewBox: "0 0 186 166",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M187.462 96.2716C185.497 113.159 177.901 132.794 162.729 141.814C139.807 155.446 141.725 176.412 96.9827 185.527C90.0069 186.949 83.3866 187.547 77.144 187.429C73.788 187.366 70.5399 187.091 67.4069 186.623C38.9706 182.407 19.8339 162.343 12.8132 138.123C3.57405 106.269 22.0225 85.4153 34.2503 72.8509C46.4785 60.2865 55.4342 21.1373 99.35 11.8259C106.046 10.4091 112.894 9.6863 119.739 9.85962C135.364 10.2487 152.407 15.457 164.2 26.3271C165.085 27.1439 165.946 27.9907 166.785 28.8634C183.176 45.9409 190.141 73.248 187.462 96.2716Z",
    fill: "#212B50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M187.462 96.2716C185.497 113.159 177.901 132.794 162.729 141.814C139.807 155.446 141.725 176.412 96.9827 185.527C90.0069 186.949 83.3866 187.547 77.144 187.429C73.788 187.366 70.5399 187.091 67.4069 186.623C38.9706 182.407 19.8339 162.343 12.8132 138.123C3.57405 106.269 22.0225 85.4153 34.2503 72.8509C46.4785 60.2865 55.4342 21.1373 99.35 11.8259C106.046 10.4091 112.894 9.6863 119.739 9.85962C135.364 10.2487 152.407 15.457 164.2 26.3271C165.085 27.1439 165.946 27.9907 166.785 28.8634C183.176 45.9409 190.141 73.248 187.462 96.2716Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M184.586 114.302H190.629",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99402 114.302H181.876",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M175.305 66.9973V63.8348L172.321 63.4017C172.044 61.8524 171.45 60.4153 170.607 59.1641L172.422 56.7074L170.219 54.4713L167.807 56.3067C166.579 55.4433 165.168 54.8317 163.644 54.5412L163.215 51.5007H160.1L159.673 54.5295C158.147 54.8106 156.731 55.4134 155.499 56.2691L153.078 54.4272L150.875 56.6634L152.684 59.1112C151.833 60.358 151.23 61.7905 150.944 63.3379L147.949 63.7726V66.9351L150.933 67.3682C151.21 68.9175 151.804 70.3545 152.647 71.6057L150.832 74.0625L153.035 76.2986L155.446 74.4632C156.675 75.3266 158.086 75.9382 159.61 76.2287L160.038 79.2688H163.154L163.58 76.24C165.107 75.9588 166.522 75.3561 167.755 74.5008L170.175 76.3426L172.378 74.1065L170.57 71.6587C171.421 70.4119 172.023 68.9789 172.309 67.432L175.305 66.9973ZM161.627 73.0521C157.455 73.0521 154.073 69.6193 154.073 65.3849C154.073 61.1506 157.455 57.7178 161.627 57.7178C165.798 57.7178 169.18 61.1506 169.18 65.3849C169.18 69.6193 165.798 73.0521 161.627 73.0521Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M183.94 85.8674V83.6058L181.806 83.2959C181.608 82.1881 181.184 81.1604 180.581 80.2655L181.878 78.5089L180.303 76.9099L178.579 78.2225C177.7 77.6052 176.691 77.1676 175.601 76.96L175.295 74.7856H173.067L172.761 76.9515C171.67 77.1527 170.658 77.5833 169.776 78.1954L168.046 76.8784L166.47 78.4774L167.763 80.2279C167.155 81.1196 166.724 82.1441 166.52 83.2503L164.378 83.5613V85.8229L166.512 86.1328C166.71 87.2406 167.134 88.2683 167.737 89.1632L166.44 90.9198L168.015 92.5188L169.739 91.2062C170.618 91.8235 171.627 92.2611 172.717 92.4687L173.023 94.643H175.251L175.557 92.4772C176.648 92.276 177.66 91.8453 178.542 91.2333L180.272 92.5503L181.848 90.9513L180.555 89.2008C181.163 88.3091 181.594 87.2846 181.798 86.1784L183.94 85.8674ZM174.159 90.1974C171.175 90.1974 168.757 87.7427 168.757 84.7143C168.757 81.686 171.175 79.2313 174.159 79.2313C177.142 79.2313 179.56 81.686 179.56 84.7143C179.56 87.7427 177.142 90.1974 174.159 90.1974Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4738 84.3115V87.1973L29.1965 87.5928C29.4492 89.0064 29.9909 90.3178 30.7602 91.4595L29.1045 93.7013L31.1148 95.7419L33.3154 94.0673C34.4361 94.8551 35.7241 95.4135 37.1147 95.6785L37.5055 98.4528H40.3484L40.7381 95.689C42.1307 95.4324 43.4226 94.8826 44.5473 94.1017L46.7558 95.7823L48.7661 93.7417L47.1164 91.508C47.8925 90.3703 48.4426 89.063 48.7036 87.6514L51.4367 87.2547V84.3689L48.714 83.9734C48.4613 82.5598 47.9196 81.2484 47.1503 80.1067L48.8059 77.8649L46.7956 75.8243L44.5951 77.4989C43.4743 76.7111 42.1864 76.1528 40.7958 75.8877L40.4049 73.1135H37.562L37.1728 75.8772C35.7802 76.1338 34.4883 76.6836 33.3635 77.4645L31.155 75.7839L29.1447 77.8245L30.7944 80.0582C30.0183 81.1959 29.4683 82.5032 29.2072 83.9148L26.4738 84.3115ZM38.9554 78.7864C42.7619 78.7864 45.848 81.9186 45.848 85.7829C45.848 89.6468 42.7623 92.7794 38.9554 92.7794C35.1486 92.7794 32.0629 89.6472 32.0629 85.7829C32.0629 81.9186 35.1486 78.7864 38.9554 78.7864Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4407 68.6024V70.3626L21.1016 70.6038C21.256 71.4659 21.5863 72.2659 22.0556 72.9624L21.0454 74.3299L22.2717 75.5746L23.6141 74.5529C24.2979 75.0333 25.0835 75.3742 25.9317 75.5354L26.1701 77.2278H27.9042L28.1418 75.5419C28.9911 75.3851 29.7792 75.0498 30.4653 74.5735L31.8125 75.5989L33.0388 74.3541L32.0322 72.9914C32.5055 72.2974 32.841 71.4999 33.0002 70.6389L34.6674 70.3969V68.6367L33.0065 68.3955C32.8521 67.533 32.5218 66.7335 32.0529 66.037L33.063 64.6694L31.8368 63.4247L30.4944 64.4464C29.8106 63.9661 29.0249 63.6251 28.1768 63.4639L27.9384 61.7715H26.2043L25.9667 63.4574C25.117 63.6138 24.3293 63.9495 23.6432 64.4254L22.296 63.4001L21.0697 64.6448L22.0763 66.0075C21.603 66.7016 21.2675 67.4991 21.1083 68.36L19.4407 68.6024ZM27.0544 65.2322C29.3764 65.2322 31.2589 67.1427 31.2589 69.5001C31.2589 71.857 29.3768 73.7675 27.0544 73.7675C24.7325 73.7675 22.85 71.857 22.85 69.5001C22.85 67.1427 24.7325 65.2322 27.0544 65.2322Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M86.245 36.4804V38.8979L88.5259 39.2292C88.7377 40.4133 89.1914 41.5118 89.8358 42.4685L88.4487 44.3462L90.1327 46.0556L91.9762 44.6529C92.9151 45.3126 93.9941 45.7804 95.159 46.0022L95.4866 48.3261H97.8682L98.1945 46.0107C99.3611 45.7958 100.443 45.3352 101.386 44.6812L103.236 46.0891L104.92 44.3798L103.537 42.5085C104.187 41.5554 104.648 40.4602 104.867 39.2777L107.156 38.9452V36.5276L104.875 36.1964C104.663 35.0122 104.21 33.9138 103.565 32.9571L104.952 31.0793L103.268 29.37L101.425 30.7727C100.486 30.1129 99.4069 29.6451 98.2419 29.4233L97.9144 27.0995H95.5327L95.2064 29.4148C94.0398 29.6297 92.9577 30.0903 92.0152 30.7444L90.1653 29.3364L88.4814 31.0458L89.8636 32.9171C89.2137 33.8701 88.7528 34.9654 88.5343 36.1475L86.245 36.4804ZM96.7005 31.8521C99.8892 31.8521 102.474 34.4761 102.474 37.713C102.474 40.9498 99.8892 43.5738 96.7005 43.5738C93.5117 43.5738 90.9267 40.9498 90.9267 37.713C90.9267 34.4761 93.5117 31.8521 96.7005 31.8521Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M158.394 116.923H42.5605V39.5787C42.5605 37.8003 43.9809 36.3584 45.7329 36.3584H155.222C156.974 36.3584 158.395 37.8003 158.395 39.5787L158.394 116.923Z",
    fill: "black",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M175.77 152.538H25.185L42.5601 116.923H158.394L175.77 152.538Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M151.378 42.7375H49.5765V110.544H151.378V42.7375Z",
    fill: "#212B50",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M95.6454 128.196L95.8464 123.857H89.7259L89.3204 128.196H95.6454Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M108.296 128.196L108.087 123.857H101.966L101.97 128.196H108.296Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M141.239 132.837H147.783L146.246 128.196H139.921L141.239 132.837Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3204 128.196L89.7259 123.857H83.6051L82.9954 128.196H89.3204Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6703 128.196L77.485 123.857H71.3642L70.3449 128.196H76.6703Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M133.596 128.196L132.569 123.857H126.449L127.271 128.196H133.596Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M139.921 128.196L138.689 123.857H132.569L133.596 128.196H139.921Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3449 128.196L71.3642 123.857H65.2441L64.0199 128.196H70.3449Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M114.621 128.196L114.207 123.857H108.087L108.296 128.196H114.621Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M146.246 128.196L144.81 123.857H138.689L139.921 128.196H146.246Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M127.271 128.196L126.449 123.857H120.328L120.946 128.196H127.271Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M120.946 128.196L120.328 123.857H114.207L114.621 128.196H120.946Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M101.97 128.196L101.966 123.857H95.8464L95.6454 128.196H101.97Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6949 128.196H51.3698L49.6234 132.837H56.1669L57.6949 128.196Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1237 123.857H53.0033L51.3699 128.196H57.6949L59.1237 123.857Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0199 128.196L65.2441 123.857H59.1237L57.6949 128.196H64.0199Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7517 137.81L45.741 143.152H52.7712L54.53 137.81H47.7517Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M56.167 132.837H49.6234L47.7516 137.81H54.53L56.167 132.837Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M54.53 137.81L52.7712 143.152H59.8015L61.3083 137.81H54.53Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9954 128.196L83.6051 123.857H77.4851L76.6703 128.196H82.9954Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M82.343 132.837L82.9953 128.196H76.6703L75.7991 132.837H82.343Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7991 132.837L76.6703 128.196H70.3449L69.2552 132.837H75.7991Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8869 132.837L89.3204 128.196H82.9953L82.343 132.837H88.8869Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0199 128.196H57.6949L56.1669 132.837H62.7112L64.0199 128.196Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M142.65 137.81H149.429L147.783 132.837H141.239L142.65 137.81Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2552 132.837L70.3449 128.196H64.0199L62.7112 132.837H69.2552Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1669 132.837L54.53 137.81H61.3083L62.7113 132.837H56.1669Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M128.15 132.837L127.271 128.196H120.946L121.606 132.837H128.15Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M121.606 132.837L120.946 128.196H114.621L115.063 132.837H121.606Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M141.239 132.837L139.921 128.196H133.596L134.694 132.837H141.239Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M101.975 132.837L101.97 128.196H95.6454L95.4308 132.837H101.975Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M115.063 132.837L114.621 128.196H108.296L108.519 132.837H115.063Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M108.519 132.837L108.296 128.196H101.97L101.975 132.837H108.519Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4308 132.837L95.6453 128.196H89.3203L88.8869 132.837H95.4308Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M115.063 132.837L115.536 137.81H122.315L121.607 132.837H115.063Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M121.607 132.837L122.315 137.81H129.093L128.15 132.837H121.607Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7112 132.837L61.3083 137.81H68.087L69.2552 132.837H62.7112Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M128.15 132.837L129.093 137.81H135.872L134.694 132.837H128.15Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M101.975 132.837L101.979 137.81H108.758L108.519 132.837H101.975Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M134.694 132.837L135.872 137.81H142.65L141.239 132.837H134.694Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M108.519 132.837L108.758 137.81H115.536L115.063 132.837H108.519Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7991 132.837L74.8654 137.81H81.6438L82.343 132.837H75.7991Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2552 132.837L68.087 137.81H74.8654L75.7991 132.837H69.2552Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4309 132.837L95.2008 137.81H101.979L101.975 132.837H95.4309Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8869 132.837L88.4225 137.81H95.2008L95.4309 132.837H88.8869Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M82.343 132.837L81.6437 137.81H88.4225L88.8869 132.837H82.343Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M134.694 132.837L133.596 128.196H127.271L128.15 132.837H134.694Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1237 123.857L60.5859 119.415H54.6752L53.0032 123.857H59.1237Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0032 123.857H47.3536L45.5312 128.196H51.3699L53.0032 123.857Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6752 119.415H49.2187L47.3536 123.857H53.0032L54.6752 119.415Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3699 128.196H45.5312L43.5826 132.837H49.6234L51.3699 128.196Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6234 132.837H43.5826L41.4943 137.81H47.7516L49.6234 132.837Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7516 137.81H41.4943L39.2512 143.152H45.7409L47.7516 137.81Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M152.571 128.196L154.326 132.837H160.115L158.167 128.196H152.571Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M156.207 137.81H162.203L160.115 132.837H154.326L156.207 137.81Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M158.228 143.152H164.447L162.203 137.81H156.207L158.228 143.152Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M108.087 123.857L107.873 119.415H101.962L101.966 123.857H108.087Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M152.571 128.196H158.167L156.344 123.857H150.93L152.571 128.196Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M149.429 137.81H156.207L154.327 132.837H147.783L149.429 137.81Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2442 123.857L66.4967 119.415H60.586L59.1237 123.857H65.2442Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M144.81 123.857L146.246 128.196H152.571L150.93 123.857H144.81Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M156.344 123.857L154.479 119.415H149.25L150.93 123.857H156.344Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M150.93 123.857L149.25 119.415H143.339L144.81 123.857H150.93Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M129.093 137.81L130.106 143.152H137.136L135.872 137.81H129.093Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M151.197 143.152H158.228L156.207 137.81H149.429L151.197 143.152Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M144.81 123.857L143.339 119.415H137.428L138.689 123.857H144.81Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M142.65 137.81L144.167 143.152H151.197L149.429 137.81H142.65Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M135.872 137.81L137.136 143.152H144.167L142.65 137.81H135.872Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M147.783 132.837H154.326L152.571 128.196H146.246L147.783 132.837Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7259 123.857L90.1407 119.415H84.23L83.6051 123.857H89.7259Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M138.689 123.857L137.428 119.415H131.518L132.569 123.857H138.689Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6051 123.857L84.2299 119.415H78.3189L77.485 123.857H83.6051Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M101.966 123.857L101.962 119.415H96.0517L95.8464 123.857H101.966Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M77.485 123.857L78.3188 119.415H72.4078L71.3642 123.857H77.485Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3642 123.857L72.4077 119.415H66.4966L65.2441 123.857H71.3642Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8463 123.857L96.0517 119.415H90.1406L89.7259 123.857H95.8463Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M132.569 123.857L131.518 119.415H125.606L126.449 123.857H132.569Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M126.449 123.857L125.606 119.415H119.695L120.328 123.857H126.449Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M114.207 123.857L113.785 119.415H107.874L108.087 123.857H114.207Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M129.093 137.81H122.315H115.536H108.758H101.979H95.2008H88.4225H81.6437H74.8654H68.0871H61.3083L59.8015 143.152H66.8318H73.8625H80.8927H87.9234H94.9537H101.984H109.015H116.045H123.075H130.106L129.093 137.81Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M120.328 123.857L119.695 119.415H113.785L114.207 123.857H120.328Z",
    fill: "black",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M175.838 152.538H25.185V154.708H175.838V152.538Z",
    fill: "black",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1399 48.0849H62.7029",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1399 51.506H80.796",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M94.277 51.506H118.933",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3924 51.506H92.1486",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1399 54.9271H70.3306",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1041 54.9271H86.2948",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0687 54.9271H102.259",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M104.033 54.9271H110.064",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4768 48.0849H71.0398",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M103.501 48.0849H110.064",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8092 48.0849H101.372",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8137 48.0849H91.971",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1399 68.9713H62.7029",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1399 72.3924H80.796",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M94.277 72.3924H118.933",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3924 72.3924H92.1486",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1399 75.8138H70.3306",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1041 75.8138H86.2948",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0687 75.8138H102.259",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M104.033 75.8138H110.064",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4768 68.9713H71.0398",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M103.501 68.9713H110.064",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8092 68.9713H101.372",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8137 68.9713H91.971",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1399 99.7614H62.7029",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1399 103.182H80.796",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M94.277 103.182H118.933",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3924 103.182H92.1486",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1399 106.604H70.3306",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1041 106.604H86.2948",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0687 106.604H102.259",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M104.033 106.604H110.064",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4768 99.7614H71.0398",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M103.501 99.7614H110.064",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8092 99.7614H101.372",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8137 99.7614H91.971",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0353 58.5283H99.5988",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3438 58.5283H90.9068",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3483 58.5283H81.5057",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0353 64.6501H99.5988",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3438 64.6501H90.9068",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3483 64.6501H81.5057",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9113 61.589H62.3483",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6033 61.589H71.0399",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5987 61.589H80.4414",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0353 79.9548H99.5988",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3438 79.9548H90.9068",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3483 79.9548H81.5057",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0353 86.077H99.5988",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3438 86.077H90.9068",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3483 86.077H81.5057",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9113 83.0159H62.3483",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6033 83.0159H71.0399",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5987 83.0159H80.4414",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9113 89.6779H62.3483",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6033 89.6779H71.0399",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5987 89.6779H80.4414",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9113 95.8001H62.3483",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6033 95.8001H71.0399",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5987 95.8001H80.4414",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0353 92.739H99.5988",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3438 92.739H90.9068",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3483 92.739H81.5057",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7053 46.8967H51.6099V48.9975H53.7053V46.8967Z",
    fill: "black"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7053 50.3481H51.6099V52.4489H53.7053V50.3481Z",
    fill: "black"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7053 53.7995H51.6099V55.9003H53.7053V53.7995Z",
    fill: "black"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7053 57.2512H51.6099V59.352H53.7053V57.2512Z",
    fill: "black"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7053 60.7026H51.6099V62.8034H53.7053V60.7026Z",
    fill: "black"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7053 64.154H51.6099V66.2548H53.7053V64.154Z",
    fill: "black"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7053 67.6053H51.6099V69.7061H53.7053V67.6053Z",
    fill: "black"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7053 71.0568H51.6099V73.1576H53.7053V71.0568Z",
    fill: "black"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7053 74.5085H51.6099V76.6093H53.7053V74.5085Z",
    fill: "black"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7053 77.9599H51.6099V80.0607H53.7053V77.9599Z",
    fill: "black"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7053 81.4113H51.6099V83.5121H53.7053V81.4113Z",
    fill: "black"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7053 84.8626H51.6099V86.9634H53.7053V84.8626Z",
    fill: "black"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7053 88.314H51.6099V90.4148H53.7053V88.314Z",
    fill: "black"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7053 91.7658H51.6099V93.8666H53.7053V91.7658Z",
    fill: "black"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7053 95.2172H51.6099V97.318H53.7053V95.2172Z",
    fill: "black"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7053 98.6685H51.6099V100.769H53.7053V98.6685Z",
    fill: "black"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7053 102.12H51.6099V104.221H53.7053V102.12Z",
    fill: "black"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7053 105.571H51.6099V107.672H53.7053V105.571Z",
    fill: "black"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M151.255 9.15503C138.683 9.15503 128.492 19.4999 128.492 32.261C128.492 38.8264 131.194 44.747 135.526 48.9539L132.286 55.0919L140.231 52.4764C143.498 54.3158 147.255 55.367 151.256 55.367C163.827 55.367 174.018 45.0221 174.018 32.261C174.018 19.5003 163.827 9.15503 151.255 9.15503Z",
    fill: "black",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M150.171 7.5047C137.6 7.5047 127.409 17.8495 127.409 30.6107C127.409 37.1761 130.111 43.0971 134.442 47.3035L131.202 53.4415L139.147 50.826C142.414 52.6654 146.171 53.7166 150.171 53.7166C162.743 53.7166 172.934 43.3718 172.934 30.6107C172.934 17.8495 162.743 7.5047 150.171 7.5047Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M142.549 40.1329L133.802 33.862V30.54L142.549 24.2068V27.5596L136.28 32.1854L142.549 36.8112V40.1329Z",
    fill: "#212B50"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M145.209 41.2508L151.877 16.1042H154.721L148.023 41.2504L145.209 41.2508Z",
    fill: "#212B50"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M157.382 40.1329V36.8112L163.682 32.1543L157.382 27.5596V24.2068L166.159 30.5088V33.8305L157.382 40.1329Z",
    fill: "#212B50"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M143.633 38.7577L134.886 32.4864V29.1647L143.633 22.8316V26.1844L137.363 30.8102L143.633 35.436V38.7577Z",
    fill: "black"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M146.294 39.8752L152.961 14.729H155.805L149.108 39.8752H146.294Z",
    fill: "black"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M158.466 38.7577V35.436L164.766 30.7791L158.466 26.1844V22.8316L167.244 29.1336V32.4553L158.466 38.7577Z",
    fill: "black"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M132.866 154.946L146.649 166.496C146.649 166.496 147.462 168.696 149.359 171.172C151.256 173.648 173.476 183 173.476 183L177.27 184.1L135.809 152.467L132.866 154.946Z",
    fill: "black",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M159.708 145.771C159.708 145.771 156.01 141.184 154.367 138.265C152.724 135.345 150.395 128.534 148.615 124.502C146.835 120.471 144.233 119.22 141.083 117.969C137.933 116.718 136.701 116.996 136.701 117.83C136.701 118.664 137.933 120.193 137.933 120.193L132.592 121.166C132.592 121.166 130.401 119.915 129.032 120.332C127.662 120.749 125.06 123.39 125.06 123.39C125.06 123.39 122.321 122.417 120.678 122.835C119.034 123.251 114.515 125.476 112.598 126.449C110.681 127.422 108.626 127.561 108.763 128.395C108.9 129.229 110.818 130.619 112.598 130.341C114.378 130.063 117.391 128.951 119.308 128.951C121.226 128.951 122.184 129.368 123.143 130.063C124.102 130.758 128.073 136.457 128.621 137.153C129.169 137.848 129.717 140.628 129.717 140.628C129.717 140.628 127.302 139.58 125.795 138.19C124.289 136.8 122.134 133.54 119.669 133.262C117.203 132.984 114.515 135.206 115.884 136.318C117.254 137.431 118.624 138.126 119.582 139.377C120.541 140.628 122.047 144.381 124.649 148.413C127.251 152.444 132.866 154.946 132.866 154.946L144.506 159.811C144.506 159.811 147.519 152.583 153.134 150.637C158.749 148.691 160.392 147.856 160.392 147.856L159.708 145.771Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M108.763 128.394C108.763 128.394 110.098 128.049 110.483 127.919C110.867 127.789 111.316 127.399 111.316 127.399",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M125.06 123.39C125.06 123.39 131.368 126.972 133.149 127.945C133.88 128.345 135.615 129.168 136.149 130.991C136.781 133.145 138.059 134.314 138.059 134.314",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M132.592 121.166C132.592 121.166 138.755 126.031 139.166 126.17C139.576 126.309 141.083 126.448 141.768 127.699C142.452 128.95 143.137 130.34 143.137 130.34",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M137.933 120.193C137.933 120.193 140.124 119.776 140.946 121.444C141.768 123.112 145.328 127.144 145.328 127.144",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M118.349 138.126C118.349 138.126 119.993 137.292 119.171 136.041C118.349 134.789 116.706 134.789 116.706 134.789",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M159.434 143.964C159.434 143.964 152.038 145.91 147.382 151.193C142.726 156.475 142.726 160.923 143.137 161.619C143.548 162.314 152.449 167.179 152.449 167.179C152.449 167.179 157.927 156.475 161.762 153.834C165.596 151.193 168.335 150.498 168.335 150.498C168.335 150.498 161.487 146.049 161.214 145.493C160.94 144.937 160.392 143.547 159.434 143.964Z",
    fill: "#212B50",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M180.25 185.807C180.25 185.807 172.718 181.914 170.937 180.941C169.157 179.968 156.969 173.296 156.969 173.296C156.969 173.296 155.462 172.879 154.641 172.462C153.819 172.045 152.586 172.184 152.038 169.264C151.491 166.345 152.86 160.506 159.023 154.668C165.186 148.829 169.02 149.107 169.02 149.107C169.02 149.107 171.622 148.829 172.307 149.385C172.992 149.941 173.129 151.609 173.813 151.887C174.498 152.165 193.448 157.931 193.448 157.931",
    fill: "#212B50"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M180.25 185.807C180.25 185.807 172.718 181.914 170.937 180.941C169.157 179.968 156.969 173.296 156.969 173.296C156.969 173.296 155.462 172.879 154.641 172.462C153.819 172.045 152.586 172.184 152.038 169.264C151.491 166.345 152.86 160.506 159.023 154.668C165.186 148.829 169.02 149.107 169.02 149.107C169.02 149.107 171.622 148.829 172.307 149.385C172.992 149.941 173.129 151.609 173.813 151.887C174.498 152.165 193.448 157.931 193.448 157.931",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M158.749 164.399C158.749 164.399 157.927 168.569 159.845 172.045",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2755 142.678C76.2755 142.678 67.2496 153.567 64.5401 155.768C61.8301 157.968 59.3915 159.344 59.3915 159.344L49.6361 169.246C49.6361 169.246 49.9072 170.621 47.1972 172.272C44.4872 173.922 39.0677 175.848 37.7129 176.398C36.3581 176.948 21.4538 183.825 21.4538 183.825L76.2755 142.678Z",
    fill: "black",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3721 126.012C88.4233 126.301 85.0068 126.109 85.0068 126.109C85.0068 126.109 82.9189 124.471 81.875 123.508C80.831 122.544 78.174 116.861 76.8455 116.572C75.5169 116.283 69.9179 119.558 69.9179 119.558C69.9179 119.558 65.3628 117.535 64.2237 117.728C63.0846 117.921 59.3836 121.292 59.3836 121.292C59.3836 121.292 54.259 120.521 53.3101 122.063C52.3613 123.604 50.8425 128.517 49.3241 131.6C47.8058 134.682 42.3014 142.871 42.3014 142.871L41.5421 143.93C41.5421 143.93 42.6807 144.316 46.1923 146.146C49.7034 147.976 55.3029 156.646 55.3029 156.646C55.3029 156.646 63.0846 152.985 67.4503 150.962C71.8155 148.939 75.3271 144.508 76.2759 142.678C77.2247 140.848 78.8382 139.113 80.831 137.476C82.8238 135.839 86.5252 135.164 87.3793 134.008C88.2334 132.852 86.8098 131.118 86.8098 131.118C86.8098 131.118 87.8537 130.54 88.3281 130.155C88.8026 129.77 90.7006 128.71 90.8905 127.554C91.0803 126.398 90.3209 125.723 89.3721 126.012ZM74.7571 135.26L76.5605 129.673C77.3199 130.251 80.6412 131.503 80.6412 131.503C78.4585 132.081 74.7571 135.26 74.7571 135.26Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7773 127.65C55.7773 127.65 55.4928 126.012 55.6826 125.434C55.8724 124.856 59.3836 121.292 59.3836 121.292",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M58.814 129.577L59.573 127.072L69.9174 119.558",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9387 131.407C63.9387 131.407 64.3184 128.999 64.7928 128.613C65.2672 128.228 68.8735 127.361 68.8735 127.361C68.8735 127.361 74.3778 122.544 75.3266 122.544C76.2755 122.544 83.2035 126.301 85.0064 126.109",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0431 126.494C88.0431 126.494 86.8074 126.498 87.4716 127.268C88.1359 128.039 89.5595 127.654 90.2238 127.461",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6412 131.503C80.6412 131.503 84.0576 129.48 86.8098 131.118",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9557 131.696L84.0576 132.37C84.0576 132.37 84.817 133.911 84.9117 134.49C85.0064 135.068 85.0065 135.068 85.0065 135.068",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M74.7571 135.26L73.0489 139.113",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6796 150.191C29.6796 150.191 35.6584 146.242 37.841 144.604C40.0236 142.966 41.1627 143.256 42.3014 142.87C43.4401 142.485 49.1343 144.219 52.9304 149.035C56.7265 153.852 56.3468 157.416 55.8724 158.379C55.398 159.342 43.4405 166.664 43.4405 166.664C43.4405 166.664 41.7323 159.728 36.7027 155.586C31.6724 151.444 29.6796 150.191 29.6796 150.191Z",
    fill: "#212B50",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M5.76462 161.716C5.76462 161.716 16.8402 154.846 18.6861 153.718C20.532 152.59 22.6693 151.052 22.6693 151.052C22.6693 151.052 23.2523 148.079 26.0698 147.976C28.8872 147.874 31.6076 149.002 35.2994 151.052C38.9913 153.103 43.5575 160.588 44.0431 163.562C44.5286 166.535 45.5001 167.458 44.7233 169.406C43.946 171.355 41.0314 171.457 40.4483 171.457C39.8653 171.457 38.5053 172.688 38.5053 172.688L17.7146 186.428",
    fill: "#212B50"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M5.76462 161.716C5.76462 161.716 16.8402 154.846 18.6861 153.718C20.532 152.59 22.6693 151.052 22.6693 151.052C22.6693 151.052 23.2523 148.079 26.0698 147.976C28.8872 147.874 31.6076 149.002 35.2994 151.052C38.9913 153.103 43.5575 160.588 44.0431 163.562C44.5286 166.535 45.5001 167.458 44.7232 169.406C43.946 171.355 41.0314 171.457 40.4483 171.457C39.8653 171.457 38.5053 172.688 38.5053 172.688L17.7146 186.428",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1303 166.237C40.1303 166.237 40.9996 166.892 39.2611 169.644",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubbento0);
export default __webpack_public_path__ + "static/media/subbento0.93198c5a76a337226daba5ed92f3f729.svg";
export { ForwardRef as ReactComponent };